module.exports = __webpack_public_path__ + "static/media/profile-pic-2.496b27fd.png";